import React, { useState } from 'react'
import MilesBonusIcon from '../../Base/IconComponents/MilesBonusIcon'
import { useSelector } from 'react-redux'
import constants from '../../../../js/lib/constants'
import showMilesNBonus from '../../../../js/helpers/showMilesNBonus'

const MilesBonusAlert = () => {
  const { dictionary } = window.bookingData
  const { step, milesNBonusAccount, selectedVehicle, isPrepaid, filters } =
    useSelector((state) => state.booking)
  const [showComponent, setShowComponent] = useState(true)

  const isMBLoggedIn = !!milesNBonusAccount?.fFN
  const isResultsStep = step === constants.booking.pageNumber.vehicles
  const alertMessage = isMBLoggedIn
    ? dictionary.milesAlertMessageLoggedIn
    : dictionary.milesAlertMessage

  // Get filtered cars from window data ONLY on results step (step 1)
  const records =
    window.fleetData?.records ||
    window.bookingData?.records ||
    window.inpathData?.records
  const carsData = records?.cars || []

  // Pass filtered cars only on step 1 to check if any Hertz brand exists
  const filteredCars = isResultsStep
    ? filters?.brand?.length > 0
      ? carsData.filter((car) => filters.brand.includes(car.brandCode))
      : carsData
    : null

  const handleClick = () => {
    if (isMBLoggedIn) return
    window.dispatchEvent(new CustomEvent('openLoginModal'))
  }

  const handleClose = (e) => {
    e.stopPropagation()
    setShowComponent(false)
  }

  const shouldShow =
    showComponent &&
    showMilesNBonus({
      selectedVehicle: isResultsStep ? null : selectedVehicle,
      milesNBonusAccount,
      isPrepaid,
      filteredCars,
    })

  if (!shouldShow) return null

  const CloseButton = () => (
    <button
      type="button"
      title="Close"
      className="btn p-0"
      onClick={handleClose}>
      <i className="icon-x pt-1"></i>
    </button>
  )

  const MemberInfo = () => (
    // <div className="pt-1">
    <span className="bold">{milesNBonusAccount?.fFN}</span>
    // </div>
  )

  return (
    <div
      className={`b-miles-alert ${
        !isMBLoggedIn ? 'b-miles-alert__clickable' : ''
      }`}
      onClick={handleClick}>
      <div className="page-container">
        {/* Desktop */}
        <div className="b-miles-alert__desktop">
          {isMBLoggedIn ? (
            <div className="b-miles-alert__logged-in">
              <MilesBonusIcon width={95} height={12} />
              <div className="b-miles-alert__miles">
                <MemberInfo />
                <div className="bold">{alertMessage}</div>
              </div>
            </div>
          ) : (
            <div className="b-miles-alert__logged-out">
              <MilesBonusIcon width={95} height={12} />
              <div className="bold">{alertMessage}</div>
              <CloseButton />
            </div>
          )}
        </div>

        {/* Mobile */}
        <div className="b-miles-alert__mobile">
          <div className="b-miles-alert__header">
            <div className="b-miles-alert__header__miles">
              <MilesBonusIcon width={95} height={12} />
              {isMBLoggedIn && <MemberInfo />}
            </div>
            {!isMBLoggedIn && <CloseButton />}
          </div>
          <div className="bold">{alertMessage}</div>
        </div>
      </div>
    </div>
  )
}

export default MilesBonusAlert
